import { FC } from 'react';
import { Link } from 'react-router-dom';
import Logo from 'packages/lib/assets/logo.svg?react';
import styles from 'packages/lib/common-ui/public-header/public-header.module.scss';

// TODO: cleanup this component and make public header UI pretty
export const PublicHeader: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <header className={styles.header}>
      <div className="content-wide flex">
        <div>
          <Link to="/" className={'vertical-center ' + styles.logoLink}>
            <Logo className={styles.logoImg} />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
